import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getAboutUsPath(locale: Locale): string {
	return getPathInLocale(locale, "/o-nas");
}
